import { render, staticRenderFns } from "./AulaInfoTrigger.vue?vue&type=template&id=6b5486c4&scoped=true&"
import script from "./AulaInfoTrigger.vue?vue&type=script&lang=ts&"
export * from "./AulaInfoTrigger.vue?vue&type=script&lang=ts&"
import style0 from "./AulaInfoTrigger.vue?vue&type=style&index=0&id=6b5486c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5486c4",
  null
  
)

export default component.exports